const apiRoot = process.env.API_ROOT || ''
const apiRoute = (route, opts = { version: 2 }) => `${apiRoot}/api/v${opts.version}/${route}`

module.exports = apiRoute
